export const googleApiScope =
  'https://www.googleapis.com/auth/contacts.readonly';

export const contactApiUrl =
  'https://www.google.com/m8/feeds/contacts/default/thin?alt=json&access_token=';

export const referImage =
  'https://assets1.cleartax-cdn.com/ct-frontend/images/referral-com.png';
export const referImage100 =
  'https://assets1.cleartax-cdn.com/clearsave-frontend/images/referral.png';
export const googleClientJsUrl = 'https://apis.google.com/js/client.js';

export const whatsappShareUrl = 'https://api.whatsapp.com/send?text=';
export const twitterShareUrl = 'https://twitter.com/share?url=';
export const linkedinShareUrl =
  'https://www.linkedin.com/shareArticle?mini=true&url=';
export const facebookShareUrl = 'https://www.facebook.com/sharer/sharer.php?u=';

export const whatsappLogoUrl =
  'https://assets1.cleartax-cdn.com/img/whatsapp-logo.png';
export const googleLogoUrl =
  'https://assets1.cleartax-cdn.com/ct-frontend/images/google_2.png';
export const linkdinLogoUrl =
  'https://assets1.cleartax-cdn.com/ct-frontend/images/linkedin_2.png';
export const twitterLogourl =
  'https://assets1.cleartax-cdn.com/ct-frontend/images/twitter_2.png';
export const facebookLogoUrl =
  'https://assets1.cleartax-cdn.com/ct-frontend/images/facebook_2.png';

export const cleartaxShareUrl = 'https://cleartax.in/save/refer/';

export const googleDocUrl =
  'https://docs.google.com/document/d/e/2PACX-1vTUCZOD18Ty0l1Vl6pp3k3pVwEGHlyHXiorN_ZZ5YDftPu8705ABXub8yN764nvIxQ-BH0uvCqSjiMO/pub';

export const userReferralGoogleDocUrl =
  'https://docs.google.com/document/d/e/2PACX-1vTKxioxQsr7DTrIEST23HdRjrImqEpT4zT9_HQ49Gla3NF4Ga8kYcNUh4LzWSmbOHDpAqMN8e8QBarJ/pub';

export const referralShareString =
  'Invest in market-beating top funds to Save Taxes and Grow Wealth in long-term';
export const referralSuccessMessage =
  'Thank you <Referee_Name>! We will notify you once we have received an investment through one of your referrals.';

export const clientId =
  '788790720174-fn1kpj35qob5ro2p181vr6oigh3nvmo9.apps.googleusercontent.com';
export const apiKey = 'ZAE4-IWvRV9X9jQDbgYw1Yuh';

export const referralPageFaqData = [
  {
    question: 'When will a referral be considered for cash reward?',
    answer: `<p class="font--bold">The following criteria should be met for a referral to be counted for cash reward:</p>
      <ul>
        <li>-   Unique PAN number. (1 PAN = 1 referral)</li>
        <li>-   New signup. (Referral should not have signed up on ClearTax before being referred)</li>
        <li>-   Minimum amount invested by each referral should be Rs 2000. (total investment amount completed is gretaer than Rs 2000 in case of multiple investments)</li>
        <li>-   Referral investments SHOULD NOT be in Debt/Liquid Category of the Mutual Funds.</li>
      </ul>
      <p>The complete Terms and Conditions for this referral program can be found <a href=${userReferralGoogleDocUrl}>here</a></p>
      `,
  },
  {
    question: 'When will the cash reward be paid out?',
    answer:
      '<p class="font--bold">Paytm cash reward will be processed and credited to you within 30 days from when an investment is completed by your referrals.</p>',
  },
  {
    question: 'How can I refer my friends?',
    answer:
      'Invite via email: Enter the email addresses of the people you know, or invite all your Gmail contacts. ClearTax only lets you send invitations to people who are not already registered with ClearTax. Share on Facebook/Twitter: Post and tweet the world on Facebook and Twitter.',
  },

  {
    question: 'What qualifies as a successful referral?',
    answer:
      'The referee must be a new user to ClearTax. The referee must accept the invitation and then invest with ClearTax. If two people refer the same person, the sender of the email to which they accept the invitation gets the reward.',
  },

  {
    question: 'What is ClearTax Invest referral program?',
    answer:
      'Any ClearTax user can invite their friends and family to invest with ClearTax availed mutual funds. Once the referred individual completes investing with ClearTax, you will get Rs 500 reward point in your Paytm account.',
  },
];

export const caReferralPageFaqData = [
  {
    question: 'What is ClearTax Invest referral program?',
    answer:
      'ClearTax referral partners can invite their clients, co-workers, friends and family to invest with ClearTax availed mutual funds. Once the referred individual completes investing with ClearTax, you will get Rs.1000 referral amount, upon raising the tax invoice within 30 days from date of investments.',
  },
  {
    question: 'How can I refer my clients?',
    answer: `You refer your clients by one of the following way:
- Invite via email: Enter the email addresses of your client/s (ClearTax only lets you send invitations to people who are not already registered with ClearTax.)
- Share on WhatsApp
- Share on Facebook/Twitter: Post and tweet the world on Facebook and Twitter.`,
  },
  {
    question: 'Why to use the referral link?',
    answer:
      'This helps to keep a track on investments made by your references and process your referral payouts. Once your referred individual signs up, you and your referee both would get mail notifications for the successful investment, if done.',
  },
  {
    question: 'Would you contact my referrals?',
    answer:
      'We would not be soliciting your referrals unless authorised by the Partner.',
  },
  {
    question: 'What qualifies as a successful referral?',
    answer: `To be counted as a successful referral :
The referee must be a first-time investor on ClearTax.
The referee must accept the invitation and then invest with ClearTax.
If two people refer the same person, the sender of the email to which they accept the invitation gets the reward.`,
  },
  {
    question: 'Where will I see my referrals?',
    answer:
      'For each referral signup and investment, you will get an automated mail. Further, your relationship managers will share a dedicated personal dashboard where you can add details of your referrals and you will be able to track your referrals’ investments.',
  },
  {
    question: 'What kind of support will I get?',
    answer: `Once you sign up, you will be assigned a Relationship Manager who will help you with all the queries and assistance.
You can call us at <a href="tel:080-67458744">080-67458744</a> or write to us at <a href="mailto:mutualfunds@cleartax.in">mutualfunds@cleartax.in</a> for further details`,
  },
];



// WEBPACK FOOTER //
// ./constants/referralConstants.ts